import { render } from "./BodegaView.vue?vue&type=template&id=1207e349"
import script from "./BodegaView.vue?vue&type=script&lang=js"
export * from "./BodegaView.vue?vue&type=script&lang=js"

import "./BodegaView.vue?vue&type=style&index=0&id=1207e349&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__